import React, { useState, useEffect } from "react";
import Pagination from 'react-bootstrap/Pagination';
import Container from 'react-bootstrap/Container';

const columns = [
    { name: 'id', header: 'Order ID', defaultFlex: 1 },
    { name: 'items', header: 'Items', defaultFlex: 1,
        render: ({ data }) => (
            data.order_items.map(item => (
                <>{item.sizeName}<br/ ></>
            ))
        ) },
  { name: 'deliveryName', header: 'deliveryName', maxWidth: 1000, defaultFlex: 4 },
];

const gridStyle = { minHeight: 550 }


const MSMPagination = (props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(props.perPage);
  
  let pageItems = [];
  let pages = 0;

  useEffect(() => {
    setCurrentPage(1);
  }, [props.reset]);

  const gotoPage = (pagenum) => {
    if(pagenum === 'first') {
        if(currentPage == 1) return;
        pagenum = 1;
    } else if(pagenum === 'next') {
        if(currentPage + 1 <= pages) 
            pagenum = currentPage +1;
        else return;
    } else if(pagenum === 'prev') {
        if(currentPage - 1 >= 1) 
            pagenum = currentPage - 1;
        else return;
    } else if(pagenum === 'last') {
        if(currentPage === pages) return;
        pagenum = pages;
    } 

    console.log(pagenum);
    setCurrentPage(pagenum);
    const range = [ pagenum, perPage ];
    props.reload(range);
  }

    pages = Math.ceil(props.total/perPage);
    pageItems.push(<Pagination.First key="first" onClick={() => gotoPage("first")}/>);
    pageItems.push(<Pagination.Prev  key="prev" onClick={() => gotoPage("prev")}/>);
    
    for(var i=1; i<=pages; i++) {
        let idx = i;
        pageItems.push(
            <Pagination.Item key={i} active={i === currentPage} onClick={() => gotoPage(idx)}>
            {i}
            </Pagination.Item>
        )
    }
    pageItems.push(<Pagination.Next  key="next" onClick={() => gotoPage("next")}/>);
    pageItems.push(<Pagination.Last  key="last" onClick={() => gotoPage("last")}/>);


    return (
        <div className="msmpagination-container">
            <Pagination key="pagination">
                {pageItems}
            </Pagination>
        </div>
    );
};
export default MSMPagination;

